<script>
import validation from "@/components/Utility/Validation"

const PARAM = [
  {
    form_section: 'Company Profile',
  },
  {
    key: 'name',
    text: 'Company Name *',
  },
  {
    key: 'nationalID',
    text: 'Company Reg. No. *',
    form_input_attr: {
      'placeholder': 'E.g. 824592D',
    },
    form_input_validation: [
      validation.validateRequire,
      function(value, inputParameter) {
        // var re = /^[A-Z0-9]*$/;
        var re = /^[^a-z]*$/;
        if(!re.test(value)) {
          return 'Company Reg. No. must consist of capital letter, numbers and symbol only';
        }
      },
    ],
    form_muted: function() {
      if(window.location.href.includes('companyForm')) {
        return 'Use capital letters and numbers only.'
      }
    }
  },
  {
    form_section: 'Company Address',
  },
  {
    key: 'companyAddress1',
    text: 'Address 1 *',
  },
  {
    key: 'companyAddress2',
    text: 'Address 2',
    form_input_validation: [],
  },
  {
    key: 'companyAddress3',
    text: 'Address 3',
    form_input_validation: [],
  },
  {
    key: 'companyAddressPostalCode',
    text: 'Postal Code *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'companyAddressCityID',
    text: 'City *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'companyAddressStateID',
    text: 'State *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'companyAddressCountryID',
    text: 'Country *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'disabled' : 1,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    form_section: 'Company Contact',
  },
  {
    key: 'companyTelephone',
    text: 'Company Telephone No *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validateRequire,
      validation.validatePhone
    ],
  },
  {
    key: 'companyFax',
    text: 'Company Fax No',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'companyPICname',
    text: 'Company PIC Name *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'companyPICphone',
    text: 'Company PIC Phone (Mobile) *',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_phone: true,
    form_input_validation: [
      validation.validateRequire,
      validation.validatePhone
    ],
  },
  {
    key: 'companyPICemail',
    text: 'Company PIC Email *',
    form_email: true,
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [
      validation.validateRequire,
      validation.validateEmail,
    ],
    form_muted: function() {
      if(window.location.href.includes('companyForm')) {
        return 'This email address is use as Login ID and monthly season parking e-Billing.'
      }
    }
  },
];

let getParam = function(displayOnly) {
  const COMPANY_PARAM = $.extend(true, [], PARAM);
  if(displayOnly) {
    COMPANY_PARAM.forEach(k => {
      k['form_input_attr'] = k['form_input_attr'] || {};
      k['form_input_attr'].disabled = true;
    });
  }
  return COMPANY_PARAM;
}

export default {
  getParam,
}

</script>


// WEBPACK FOOTER //
// src/components/Param/CustomerCompanyParam.vue